export default __webpack_public_path__ + "static/logo-92d380b24144d8dacaaf2be959f21ed6.png";